@if (nachrichtHistorie?.length) {
    <div i18nRerenderOnLanguageChange></div>
    <div>
        <button
                class="ba-btn dropdown-toggle"
                id="btn-verlauf"
                [attr.aria-expanded]="!isCollapsed"
                [class.collapsed]="isCollapsed"
                (click)="toggleCollapse()"
        >
            {{ 'sendmail.form.show-history' | i18next }}
        </button>

        <div class="collapse pt-3" [class.show]="!isCollapsed" id="collapse-history" role="tabpanel">
            <h5 class="h4 mb-3">
                {{ 'sendmail.form.history' | i18next }}
            </h5>

            @for (historyElem of nachrichtHistorie; track $index; let i = $index; let last = $last) {
                <div class="my-3">
                    <strong>
                        {{ nachrichtHistorie.length - i }} von {{ nachrichtHistorie.length }}:
                    </strong>

                    <pf-nachricht-detail
                            [dateTime]="getPostfachFormat(historyElem.datum)"
                            [sender]="personDisplayService.displayName(historyElem.senderName, historyElem.senderId)"
                            [autor]="personDisplayService.displayName(historyElem.autorName, historyElem.autorId)"
                            [empfaenger]="personDisplayService.displayName(historyElem.empfaengerName, historyElem.empfaengerId)"
                            [text]="historyElem.text"
                            [betreffSmall]="true"
                            [anhaengeNamen]="historyElem.anhaengeNamen"
                    ></pf-nachricht-detail>
                </div>

                @if (!last) {
                    <hr class="mx-0 mb-4" aria-hidden="true">
                }
            }
        </div>
    </div>
}